import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const BillPage = lazy(() => import('../pages/bill/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const AccessibilityPage = lazy(() => import('../pages/accessibility/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/what-the-bill-would-do',
    element: <BillPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/accessibility',
    element: <AccessibilityPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
